/* eslint-disable import/prefer-default-export */
/* eslint-disable react/jsx-filename-extension */
import "react-toastify/dist/ReactToastify.css";
import { ApolloProvider } from "@apollo/client";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider } from "styled-components";
import { ToastContainer } from "react-toastify";
import React from "react";
import ReactDOM from "react-dom";
import { Helmet } from "react-helmet";

import client from "./apollo/apolloClient";
import store from "./redux/store";

import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import safariBrowserVerification from "./utils/browserVerification";
import { initSentry } from "./observability/init";
import { SentryErrorBoundary } from "./observability/ErrorBoundary";
import { history } from "./router/router";

initSentry({ history });

export const theme = {
  main: "#F7F8FA",
  primary: "#00cd7e",
  danger: "#f61e44",
  chat: "#d9fed3",
  grey: "#979797",
  blue: "#192B88",
  dark: {
    main: "#000000",
    light: "rgba(0, 0, 0, 0.4)",
  },
  secondary: {
    main: "#fff",
  },
  new: {
    blue: "#fff",
    mainText: "#2C3351",
    secondaryText: "#00ff00",
  },
};

if ("serviceWorker" in navigator && !safariBrowserVerification()) {
  try {
    if (!("Notification" in window)) {
      console.log("Este navegador no admite notificaciones.");
    } else {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log("Registration successful, scope is:", registration.scope);
        })
        .catch((err) => {
          console.error("Service worker registration failed, error:", err);
        });
    }
  } catch (error) {
    console.error(error);
  }
}

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
} else {
  // Expose Redux store for Cypress E2E tests (dev only, never in production)
  window.__store__ = store;
}

ReactDOM.render(
  <>
    <Helmet>
      <title>iVentas</title>
    </Helmet>
    <ReduxProvider store={store}>
      <ApolloProvider client={client}>
        <ThemeProvider theme={theme}>
          <SentryErrorBoundary>
            <App />
          </SentryErrorBoundary>
          <ToastContainer />
        </ThemeProvider>
      </ApolloProvider>
    </ReduxProvider>
  </>,
  document.getElementById("root")
);

serviceWorker.unregister();
